import { render, staticRenderFns } from "./OutSide.vue?vue&type=template&id=2f28c22a&scoped=true"
import script from "./OutSide.vue?vue&type=script&lang=js"
export * from "./OutSide.vue?vue&type=script&lang=js"
import style0 from "./OutSide.vue?vue&type=style&index=0&id=2f28c22a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f28c22a",
  null
  
)

export default component.exports